// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1SJ_C","content":"RecentSearches_content__3LQue"};